import { EVENTS_SELECT, LOGIN } from '../../constants/actions';
import { LOCATION_CHANGE } from 'react-router-redux';

const initialState = {
    items: [],
    selected: '',
    fetched: false,
    fetching: false
};

function events(state = initialState, action) {
    switch (action.type) {
        case EVENTS_SELECT.FETCH_START:
            return { ...state, fetching: true };
        case EVENTS_SELECT.FETCH_OK:
            return { ...state, items: action.events, fetched: true };
        case EVENTS_SELECT.CHANGE:
            return { ...state, selected: action.value };
        case LOGIN.CANCEL:
            return initialState;
        case LOCATION_CHANGE:
        default:
            return state;
    }
}

export default events;
